import qs from "qs";
import { FilterDef, HTTPGenericResponse } from "../../constants/FinanceModels";
import { getFilterValue } from "../../utils/FilterUtils";
import { useApi } from "../Api";
import * as Const from "../../pages/payments/pages/components/filters/ToolsConstants";
import dayjs from "dayjs";
import {useContext} from "react";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import {
  ID_FILTER_DEALERS,
  ID_FILTER_LEGAL_ENTITIES
} from "../../pages/payments/pages/components/filters/ToolsConstants";

export const usePaymentToolsRepository = () => {
  const { GET } = useApi();

  const PATH = "/finance/payment-tools";
  const {  globalData: { user } } = useContext(GlobalContext);
  const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);

  function getPaymentTools(
    offset: number,
    limit: number,
    sort: string | null,
    order: string | null,
    filterDefs: FilterDef[] = [],
    customerId: string | null
  ): Promise<HTTPGenericResponse> {
    let fromCreationDate: Date = getFilterValue(
      Const.ID_FILTER_CREATION_DATE_FROM,
      filterDefs
    );
    let toCreationDate: Date = getFilterValue(
      Const.ID_FILTER_CREATION_DATE_TO,
      filterDefs
    );
    let fromExpirationDate: Date = getFilterValue(
      Const.ID_FILTER_DUE_DATE_FROM,
      filterDefs
    );
    let toExpirationDate: Date = getFilterValue(
      Const.ID_FILTER_DUE_DATE_TO,
      filterDefs
    );
    let legalEntities: string[] = getFilterValue(ID_FILTER_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
    let dealers: string[] = getFilterValue(ID_FILTER_DEALERS, filterDefs);

    let params = {
      offset: offset,
      limit: limit,
      sort: sort,
      order: order,
      owner: getFilterValue(Const.ID_FILTER_OWNER, filterDefs),
      cardType: getFilterValue(Const.ID_FILTER_CARD_TYPE, filterDefs),
      cardNetwork: getFilterValue(Const.ID_FILTER_CARD_NETWORK, filterDefs),
      countryOfIssue: getFilterValue(Const.ID_FILTER_COUNTRY, filterDefs),

      fromCreationDate: fromCreationDate
        ? dayjs(fromCreationDate).toISOString()
        : null,
      toCreationDate: toCreationDate
        ? dayjs(toCreationDate).toISOString()
        : null,

      fromExpirationDate: fromExpirationDate
        ? dayjs(fromExpirationDate).toISOString()
        : null,
      toExpirationDate: toExpirationDate
        ? dayjs(toExpirationDate).toISOString()
        : null,
      customerId: customerId ? customerId : getFilterValue(Const.ID_FILTER_CUSTOMER_ID, filterDefs),
      issuer: getFilterValue(Const.ID_FILTER_ISSUER, filterDefs),
      category: getFilterValue(Const.ID_FILTER_CATEGORY, filterDefs),
      correlationName: getFilterValue(Const.ID_FILTER_CORRELATION_NAME, filterDefs),
      correlationId: getFilterValue(Const.ID_FILTER_CORRELATION_ID, filterDefs),
      pan: getFilterValue(Const.ID_FILTER_PAN, filterDefs),
      legalEntities: legalEntities,
      dealers: dealers
    };

    return GET(`${PATH}/list`, {
      params: params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat", skipNulls: true }),
    });
  }

  function getSummary(
    filterDefs: FilterDef[] = []
  ): Promise<HTTPGenericResponse> {
    let fromCreationDate: Date = getFilterValue(
      Const.ID_FILTER_CREATION_DATE_FROM,
      filterDefs
    );
    let toCreationDate: Date = getFilterValue(
      Const.ID_FILTER_CREATION_DATE_TO,
      filterDefs
    );
    let fromExpirationDate: Date = getFilterValue(
      Const.ID_FILTER_DUE_DATE_FROM,
      filterDefs
    );
    let toExpirationDate: Date = getFilterValue(
      Const.ID_FILTER_CREATION_DATE_TO,
      filterDefs
    );

    let legalEntities: string[] = getFilterValue(ID_FILTER_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
    let dealers: string[] = getFilterValue(ID_FILTER_DEALERS, filterDefs);

    let params = {
      owner: getFilterValue(Const.ID_FILTER_OWNER, filterDefs),
      cardType: getFilterValue(Const.ID_FILTER_CARD_TYPE, filterDefs),
      cardNetwork: getFilterValue(Const.ID_FILTER_CARD_NETWORK, filterDefs),
      countryOfIssue: getFilterValue(Const.ID_FILTER_COUNTRY, filterDefs),

      fromCreationDate: fromCreationDate
        ? dayjs(fromCreationDate).toISOString()
        : null,
      toCreationDate: toCreationDate
        ? dayjs(toCreationDate).toISOString()
        : null,

      fromExpirationDate: fromExpirationDate
        ? dayjs(fromExpirationDate).toISOString()
        : null,
      toExpirationDate: toExpirationDate
        ? dayjs(toExpirationDate).toISOString()
        : null,
      legalEntities: legalEntities,
      dealers: dealers
    };

    return GET(`${PATH}/all-status-summary`, {
      params: params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat", skipNulls: true }),
    });
  }

  async function getCountries() {
    let params = {
      legalEntities: allLegalEntities
    }
    return await GET(`${PATH}/countries`, {
      params: params,
      paramsSerializer: (params) =>
          qs.stringify(params, { arrayFormat: "repeat", skipNulls: true }),
    });
  }


  return {
    getPaymentTools,
    getSummary,
    getCountries
  };
};
